<template>
  <AdmPanel>
    <h2 slot="header_title">一票否决规则管理</h2>
    <div slot="header_buttons" class="adm-buttons">
      <iv-button type="primary" 
        v-rbac-allow="['carbonCompanyVote','create']"
        @click="onModalShown('create', true, null)">
        <iv-icon type="md-add" size="16" />
        <span>增加否决公司规则</span>
      </iv-button>
    </div>
    <FilterBar slot="tools" :value="conditions" :condition="options.filter_rules" @search="changeQuery()">
      <iv-form-item>
        <iv-button :disabled="loader[COMPANY_VOTE]" type="info" @click="changeQuery()">
          <iv-icon type="md-search" size="14" style="vertical-align: text-bottom" />
          <span> 查询</span>
        </iv-button>
      </iv-form-item>
    </FilterBar>
    <iv-table class="adm-table" :columns="columns" :loading="loader[COMPANY_VOTE]" :data="list.data"> </iv-table>
    <p slot="footer" style="line-height: 3;">备注：应用一票否决规则的公司不进入任何榜单的排名，但是参与得分计算！</p>
    <template v-if="list.last_page > 1">
      <div slot="footer" class="pull-right">
        <iv-page @on-change="pageChanged" :current="list.current_page" :page-size="10" show-elevator show-total :total="list.total"> </iv-page>
      </div>
    </template>
    <companyVoteModal
      :title="modal.create.title"
      :width="modal.create.width"
      :shown="modal.create.shown"
      :type="modal.create.type"
      :value="modal.create.value"
      @shown-changed="modal.create.shown=$event"
      @input="modal.create.value=$event"
      @success="refresh()"
    />
  </AdmPanel>
</template>
<script>
import CarbonCompanyModel from "@/models/CarbonCompanyModel";
import CarbonCompanyVoteModel from "@/models/CarbonCompanyVoteModel";
import CarbonIndustryModel from "@/models/CarbonIndustryModel";

import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";
import { conditioner, carbon_years, getProductYear } from "@/utils/";
import FilterBar from "@/components/FilterBar_X2";
import debounce from "lodash.debounce";
import companyVoteModal from "./companyVoteModal"

const COMPANY = CarbonCompanyModel.ModelName;
const COMPANY_VOTE = CarbonCompanyVoteModel.ModelName;
const INDUSTRY = CarbonIndustryModel.ModelName;

const options = {
    year:[],
}

const filter_rules = [
  { name: "year", type: "Select", options: carbon_years(), title: "项目年", default: "", placeholder: "项目年", clearable: true },
];

const _conditioner = conditioner(
  {
    //ui到url
    limit: { type: Number, default: 10 },
    year: { type: Number, default: "" },
  },
  {
    //url到ui
    limit: { type: Number, default: 10 },
    year: { type: Number, default: "" },
  }
);

function columns(vm) {
  const allowEdit = vm.$rbac.allow(['carbonCompanyVote', 'edit'])
  const allowDel = vm.$rbac.allow(['carbonCompanyVote', 'delete'])
  const columns = [
    {
      title: "年份",
      key: "year",
      align: "center",
      minWidth: 60,
    },
    {
      title: "证券代码",
      key: "stockCode",
      align: "center",
      minWidth: 80,
    },
    {
      title: "公司简称",
      key: "companyInfoAbbreviation",
      align: "center",
      minWidth: 120,
    },
    {
      title: "公司全称",
      key: "companyInfoCompanyName",
      align: "center",
      minWidth: 150,
    },
    // {
    //   title: "所属行业",
    //   key: "companyInfoIndustry",
    //   align: "center",
    //   minWidth: 90,
    // },
    {
      title: "否决原因",
      key: "reason",
      align: "center",
      minWidth: 150,
      render: (h, params) => {
        const link = <a href={ params.row.link } target="__blank"><iv-icon type="md-link" /></a>
        return <span>{params.row.reason} { params.row.link?link:"" }</span>;
      },
    },
  ];
  if(allowEdit || allowDel) columns.push({
    title: "操作",
    key: "tools",
    align: "center",
    minWidth: 120,
    render (h, params) {
      const item = params.row;

      const btnEdit = <a href="javascript:;" onClick={ ()=>vm.onModalShown('edit', true, item) }>修改</a>
      const $delPoptip = h('iv-poptip', {
            props: {
              transfer: true,
              confirm: true,
              title: "确认删除规则，恢复此公司榜单排名吗？"
            },
            on: {
              'on-ok': ()=>vm.del(item)
            }
          }, [<a href="javascript:;">删除</a>])

      return (
          <adm-link-group>
              { allowEdit ? btnEdit:'' }
              { allowDel ? $delPoptip : '' }
          </adm-link-group>
      );
    }
  })
  return columns
}
export default {
  name: "company",
  mixins: [
    LoaderMixin(COMPANY,COMPANY_VOTE, INDUSTRY),
    ModelMixin({
      contact,
      models: [
        [CarbonCompanyVoteModel, { emulateIdKey:'id' }],
        CarbonCompanyModel,
        CarbonIndustryModel
      ],
    }),
  ],
  data() {
    return {
      columns: columns(this),
      conditions: {
        ..._conditioner.default(),
      },
      COMPANY,
      COMPANY_VOTE,
      INDUSTRY,
      list: {
        data: [],
        last_page: 0,
        current_page: 1,
      },
      options: {
        ...options,
        filter_rules,
      },
      industries: [],
      modal: {
          create: {
            shown: false,
            title: "增加否决公司规则",
            width: 600,
            value: null,
            type: 'create'
          }
      }
    };
  },
  async mounted() {
    const { query, params } = this.$route;
    this.conditions = _conditioner.serialize({ ...query, ...params }); //处理成支持UI的格式
    this.refresh();
  },
  beforeRouteUpdate(to, from, next) {
    this.$nextTick(async () => {
      const { query, params } = to;
      this.conditions = {
        ..._conditioner.default(),
        ..._conditioner.serialize({ ...query, ...params }), //处理成支持UI的格式
      };
      this.refresh();
    });
    next();
  },
  methods: {
    searchCompanyDE: debounce(function(){ this.searchCompany() } ,250),
    async refresh(query = this.conditions) {
      this.list = await this.$$fetch(COMPANY_VOTE, _conditioner.parse(query));
      this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1;
      this.list.last_page = this.list.total / _conditioner.parse(query).limit;
    },
    async searchCompany(query={abbreviation: this.modal.create.abbreviation}){
      this.modal.create.list = await this.$$fetch(COMPANY, _conditioner.parse(query));
      this.modal.create.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1;
      this.modal.create.list.last_page = this.modal.create.list.total / _conditioner.parse(query).limit;
    },
    pageChanged(page) {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: (page - 1) * _conditioner.parse(this.conditions).limit }, params: this.$route.params });
    },
    mergeQuery(query) {
      return { ...this.conditions, ...query };
    },
    changeQuery(query = this.conditions, params = this.$route.params) {
      this.$router.push({
        name: this.$route.name,
        query: { ..._conditioner.parse(query), offset: 0 },
        params: params,
      });
    },
    onModalClose(type){
      if(type=='create'){
        this.modal.create.abbreviation = ""
        this.modal.create.list = { data:[] }
      }
    },
    async del(data){
      const result = await this.$$del(COMPANY_VOTE, data.id)
      if(result instanceof Error) return
      this.$$success(`${data.companyInfoAbbreviation}一票否决规则已删除`)
      this.refresh()
    },
    onModalShown(type='create', shown=true, item){
      this.modal.create.title = `${type=='create'?'新增':'编辑'}否决公司规则`
      this.modal.create.value = item
      this.modal.create.shown = shown
      this.modal.create.type = type
    }
  },
  components: {
    FilterBar,
    companyVoteModal
  },
};
</script>
<style lang="postcss" scoped>
.inline-checkList {
  display: inline-block;
  margin-right: 20px;
}
.inline-checkList >>> span {
  display: inline-block !important;
}

.inline-checkList >>> div {
  display: inline-block !important;
}
</style>
